import { useAuth } from '@clerk/clerk-react';
import { EmailApp } from '@/discovery';
import '@/discovery/styles.css';
import { env } from '@/lib/env';

/**
 * Thin mount point for the Email page (src/discovery/email). It runs on the
 * Discovery backend, so it only wires Clerk auth and that URL. Mounted at
 * `email/*`: campaigns route below /admin/email.
 */
export function AdminEmail(): JSX.Element {
  const { getToken } = useAuth();

  if (!env.discoveryApiUrl) {
    return (
      <div className="flex h-full items-center justify-center p-8 text-sm text-muted-foreground">
        Email is not configured. Set <code>VITE_DISCOVERY_API_URL</code> in your environment to enable it.
      </div>
    );
  }

  return (
    <EmailApp
      apiUrl={env.discoveryApiUrl}
      getToken={() => getToken()}
      basePath="/admin/discovery"
      emailBasePath="/admin/email"
    />
  );
}
